export default __webpack_public_path__ + "media/zurb/img/product-innovation/firefox_video_screenshot-3fc77f4325d0a1a72483d70807eb8347.png";